import { NgModule } from '@angular/core';
import { AssetToFullUrl } from './assetToFullUrl.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { CustomDatePipe } from './dateTransform.pipe';
import { FilterContactDataPipe } from './filterContactData.pipe';
import { ModuleNoAuxPipe } from './moduleNoAuxPipe.pipe';
@NgModule({
  declarations: [AssetToFullUrl, SafeHtmlPipe, CustomDatePipe, FilterContactDataPipe, ModuleNoAuxPipe],
  exports: [AssetToFullUrl, SafeHtmlPipe, CustomDatePipe, FilterContactDataPipe, ModuleNoAuxPipe],
})
export class PipesModule {}
